import { useState } from "react";
import { CheckCircle2, Image as ImageIcon } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, fmtDate } from "../lib/api";
import { Input } from "./ui/input";
import { Button } from "./ui/button";

export function PortalConfirmInline({ orderId, done, isAdmin, onDone }) {
  const [open, setOpen] = useState(false);
  const [pin, setPin] = useState("");
  const [busy, setBusy] = useState(false);
  const [status, setStatus] = useState(done || "");
  const [proof, setProof] = useState("");
  if (!isAdmin || !orderId) return null;
  if (status) return <div className={`mt-1 text-[11px] font-semibold ${status === "lunas" ? "text-emerald-400" : "text-rose-400"}`} data-testid={`portal-inline-done-${orderId}`}>{status === "lunas" ? "✓ Sudah dikonfirmasi LUNAS" : "✗ Ditolak"}</div>;
  const confirm = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/portal-orders/${orderId}/confirm`, { pin, note: "via chat" });
      toast.success(`LUNAS — aktif s/d ${fmtDate(data.expired_date)}; komisi agen cabang dibagikan`);
      setStatus("lunas"); onDone?.();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const showProof = async () => {
    try { const r = await api.get(`/portal-orders/${orderId}/bukti`, { responseType: "blob" }); setProof(URL.createObjectURL(r.data)); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="mt-1.5 space-y-1.5" data-testid={`portal-inline-${orderId}`}>
      {proof && <img src={proof} alt="bukti transfer" className="rounded-lg max-h-56 border border-border" data-testid={`portal-inline-proof-${orderId}`} />}
      <div className="flex flex-wrap items-center gap-1.5">
        {!open ? (
          <>
            <Button size="sm" className="h-7 text-[11px] bg-emerald-600 hover:bg-emerald-500 text-white" onClick={() => setOpen(true)} data-testid={`portal-inline-open-${orderId}`}><CheckCircle2 className="w-3.5 h-3.5 mr-1" /> Konfirmasi Lunas</Button>
            {!proof && <Button size="sm" variant="outline" className="h-7 text-[11px]" onClick={showProof} data-testid={`portal-inline-bukti-${orderId}`}><ImageIcon className="w-3.5 h-3.5 mr-1" /> Lihat bukti</Button>}
          </>
        ) : (
          <>
            <Input type="password" inputMode="numeric" placeholder="PIN admin" value={pin} onChange={(e) => setPin(e.target.value)} className="h-7 w-28 text-xs font-mono" data-testid={`portal-inline-pin-${orderId}`} />
            <Button size="sm" className="h-7 text-[11px] bg-emerald-600 hover:bg-emerald-500 text-white" disabled={busy || pin.length < 4} onClick={confirm} data-testid={`portal-inline-submit-${orderId}`}>{busy ? "…" : "Konfirmasi"}</Button>
            <Button size="sm" variant="ghost" className="h-7 text-[11px]" onClick={() => setOpen(false)} data-testid={`portal-inline-cancel-${orderId}`}>Batal</Button>
          </>
        )}
      </div>
    </div>
  );
}
